import { render, staticRenderFns } from "./CaraEvote.vue?vue&type=template&id=518d5fb7&scoped=true"
import script from "./CaraEvote.vue?vue&type=script&lang=js"
export * from "./CaraEvote.vue?vue&type=script&lang=js"
import style0 from "./CaraEvote.vue?vue&type=style&index=0&id=518d5fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d5fb7",
  null
  
)

export default component.exports